import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconDownloadStyle0 = gravityIconIndividualCss;

const GravityIconDownload = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '84cca7a31b7d2d3430967daa175611ba6d6473df', color: this.color, size: this.size }, h("svg", { key: 'a7358fd0224f5642d9de0cc3352d3e7bd765ac49', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '2ba4e9dfc5b5418763aaa9d317946b60888bbaa4', d: "M11.75 10H15a.4.4 0 0 1 .33.68l-4.05 4a.4.4 0 0 1-.56 0l-4-4A.4.4 0 0 1 7 10h3.25V4.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5V10ZM5.5 17.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-11Z", fill: "currentColor" }))));
    }
};
GravityIconDownload.style = GravityIconDownloadStyle0;

export { GravityIconDownload as gravity_icon_download };

//# sourceMappingURL=gravity-icon-download.entry.js.map